import { SPARK_RESOURCE_TYPES } from 'constants/common';
import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { StripeAccountAttributes } from 'types/Stripe/StripeAccount';
import { fetchWrapper } from 'utils/fetchWrapper';

type mutationVariables = Pick<StripeAccountAttributes, 'accountID'> & {
  name: string;
  displayName: string;
  email: string;
  countryID?: string;
  phone: string;
  description: string;
  website?: string;
  linkedIn?: string;
  x?: string;
  facebook?: string;
  youtube?: string;
  returnURL: string;
  refreshURL: string;
};

export function useAddMarketPlaceAccount() {
  const queryClient = useQueryClient();

  const addMarketplaceAccount = (marketplaceAccount: mutationVariables) => {
    if (!marketplaceAccount.accountID) {
      return Promise.reject('Account ID cannot be null');
    }
    const body = {
      accountID: marketplaceAccount.accountID,
      type: 'marketplaceAccounts',
      name: marketplaceAccount.name,
      displayName: marketplaceAccount.displayName,
      countryID: marketplaceAccount.countryID || 'US',
      email: marketplaceAccount.email,
      phone: marketplaceAccount.phone,
      description: marketplaceAccount.description,
      website: marketplaceAccount.website || '',
      linkedIn: marketplaceAccount.linkedIn || '',
      x: marketplaceAccount.x || '',
      facebook: marketplaceAccount.facebook || '',
      youtube: marketplaceAccount.youtube || '',
      ImageURL: '',
      returnURL:
        'https://uat-sparkup-frontend.azurewebsites.net/settings/creator',
      refreshURL:
        'https://uat-sparkup-frontend.azurewebsites.net/settings/creator',
    };

    return fetchWrapper<StripeAccountAttributes>({
      url: SPARK_RESOURCE_TYPES.STRIPE_ACCOUNT,
      method: 'POST',
      body: body,
    });
  };

  return useMutation('addMarketplaceAccount', addMarketplaceAccount, {
    onSuccess: () => {
      queryClient.invalidateQueries('marketplaceAccounts');
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Failed to add Marketplace account: ${error.message}`);
      }
    },
  });
}
